export const NAME = 'SingleHistoricalFlightStatus';



// WEBPACK FOOTER //
// ./modules/HistoricalFlightStatus/redux/Single/constants.js